import React from 'react';
import { ModalBody, ModalFooter, Button, Row, Col, Label } from 'reactstrap';
import ButtonLoader from '../Layout/Buttons/ButtonLoader';
import { ConfirmationDialogWithReasonProps } from './confirmation-dialog-with-reason.props';
import { Form, Input } from '@availity/form';
import * as yup from 'yup';
import Rodal from '../Rodal/Rodal';

const ConfirmationDialogWithReason = (
    props: ConfirmationDialogWithReasonProps
): any => {
    return props.isVisible ? (
        <Rodal
            visible={true}
            animation="slideTop"
            width={498}
            showCloseButton={false}
            onClose={() => {
                props.setIsVisible(false);
                props.setReasonForAction('');
            }}
            className="mdl-remove-group">
            <Form
                initialValues={{
                    reason: '',
                }}
                validationSchema={yup.object().shape({
                    reason: yup.string().trim().required(),
                })}
                onSubmit={() => {}}>
                <ModalBody>
                    <Row>
                        <Col sm={12}>
                            <Label className="label-textarea">
                                {props.title}
                            </Label>
                            <Input
                                autoFocus
                                type="textarea"
                                name="reason"
                                id="confirmation-reason"
                                onChange={(e: any) => {
                                    props.setReasonForAction(e.target.value);
                                }}
                            />
                        </Col>
                    </Row>
                </ModalBody>
                <ModalFooter>
                    <Button
                        type="button"
                        style={{ height: 'auto' }}
                        className="btn-cancel"
                        onClick={() => {
                            props.setReasonForAction('');
                            props.setIsVisible(false);
                        }}>
                        Cancel
                    </Button>

                    <ButtonLoader
                        buttonText={'Confirm'}
                        onClick={() => {
                            if (props.reasonForAction.trim()) {
                                props.action();
                                props.setIsVisible(false);
                            }
                        }}
                        loaderButtonText=""
                        disabled={false}
                        className="btn btn-primary"
                        isLoading={props.loader}></ButtonLoader>
                </ModalFooter>
            </Form>
        </Rodal>
    ) : (
        []
    );
};
export default ConfirmationDialogWithReason;
